// Brand wordmark. White on transparent - invert in light theme.
// Impose ONE dimension only (width OR height); the other stays auto (never distort).
import { IMAGES } from "./images";

export default function Wordmark({ height, width, className = "" }) {
  const src = IMAGES.wordmark;
  if (!src) return null;
  const style = width ? { width, height: "auto" } : height ? { height, width: "auto" } : undefined;
  return <img src={src} alt="LEBOURGEOIS" className={`crest-img ${className}`} style={style} />;
}
